import { AutogenModelRevenueDetail, AutogenRowRevenueDetail } from "./autogen/AutogenModelRevenueDetail";

export class ModelRevenueDetail extends AutogenModelRevenueDetail<RowRevenueDetail> {
    constructor() {
        super(RowRevenueDetail);
    }
}

export class RowRevenueDetail extends AutogenRowRevenueDetail {
}